<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <ele-data-table ref="table" :config="table" :row-key="getRowKey" height="calc(100vh - 180px)" highlight-current-row>
        <template>
          <!--          <el-table-column type="selection" width="45" align="center" fixed="left" :reserve-selection="true"/>-->
          <el-table-column prop="ipaddress" label="IP地址" show-overflow-tooltip />
          <el-table-column prop="port" label="端口号" show-overflow-tooltip />
          <el-table-column prop="deviceno" label="控制器编码" show-overflow-tooltip />
          <el-table-column prop="sum" label="控制器门数" show-overflow-tooltip />
          <el-table-column prop="school_area" label="放置位置" show-overflow-tooltip />
          <el-table-column prop="state" label="状态" align="center">
            <template #default="{ row }">
              <ele-dot
                :type="row.state == '0' ? 'success' : row.state == '1' ? 'danger' : 'info'"
                :text="row.state == '0' ? '正常运行' : row.state == '1' ? '已损坏' : '闲置'"
                size="10px"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="240px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="showAttendanceList(row)" icon="el-icon-edit" type="primary" :underline="false">设置考勤时间</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <el-dialog
        title="闸机考勤时间设置"
        :visible.sync="showSetTeacherAttendance"
        width="800px"
        :destroy-on-close="true"
        custom-class="ele-dialog-form"
        :lock-scroll="false"
        @closed="attendanceListForm = {}"
      >
        <ele-data-table ref="attendanceListTable" :data="attendanceListData" border :config="attendanceListTable" highlight-current-row>
          <el-table-column type="index" width="45" align="center" />
          <el-table-column label="名称" prop="attendanceName" show-overflow-tooltip>
            <template #default="{ row, $index }">
              <el-input v-if="$index === editIndex" v-model="attendanceListForm.attendanceName" placeholder="请输入名称" style="width: 95%" />
              <span v-else>{{ row.attendanceName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开始时间" prop="beginTime" show-overflow-tooltip>
            <template #default="{ row, $index }">
              <el-time-picker
                v-if="$index === editIndex"
                v-model="attendanceListForm.beginTime"
                placeholder="选择开始时间"
                value-format="HH:mm"
                format="HH:mm"
                style="width: 95%"
              />
              <span v-else>{{ row.beginTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束时间" prop="endTime" show-overflow-tooltip>
            <template #default="{ row, $index }">
              <el-time-picker
                v-if="$index === editIndex"
                v-model="attendanceListForm.endTime"
                placeholder="选择结束时间"
                value-format="HH:mm"
                format="HH:mm"
                style="width: 95%"
              />
              <span v-else>{{ row.endTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" align="center" :resizable="false">
            <template #default="{ row, $index }">
              <div v-if="$index === editIndex">
                <el-link @click="onSaveattendance(row, $index)" icon="el-icon-check" type="success" :underline="false">保存 </el-link>
                <el-link @click="onCancelattendance(row, $index)" icon="el-icon-close" type="warning" :underline="false">取消 </el-link>
              </div>
              <div v-else>
                <el-link @click="onEditattendance(row, $index)" icon="el-icon-edit" type="primary" :underline="false">修改 </el-link>
                <span class="ele-action">
                  <el-popconfirm title="确定要删除此考勤时间吗？" @onConfirm="onRemoveattendance(row, $index)">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </span>
              </div>
            </template>
          </el-table-column>
        </ele-data-table>
        <el-button @click="addAttendance" icon="el-icon-plus" style="width: 100%; margin-top: 15px">新增考勤时间</el-button>
        <span slot="footer" class="dialog-footer">
          <el-button @click="beforeClose">取 消</el-button>
          <el-button type="primary" @click="beforeClose">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import { delAttendanceList, getAttendanceList, setAttendanceList, updateAttendanceList } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        table: {
          // 表格配置
          url: '/zj/getSchoolControllerList',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        getRowKey(row) {
          return row.id;
        },
        attendanceListTable: {
          page: false,
        },
        showSetTeacherAttendance: false,
        attendanceListData: [],
        attendanceListForm: {
          attendanceName: '',
          beginTime: null,
          endTime: null,
        },
        editIndex: null,
        editType: 1,
      };
    },
    methods: {
      // 打开设置时间弹窗
      showAttendanceList(row) {
        this.zjId = row.id;
        this.getTimeList(row.id);
        this.showSetTeacherAttendance = true;
      },
      // 获取考勤时间
      getTimeList(id) {
        getAttendanceList({ id: id }).then((res) => {
          if (res.data.resCode == 200) {
            this.attendanceListData = res.data.data;
          }
        });
      },
      // 新增考勤时间
      addAttendance() {
        this.editType = 1;
        if (this.attendanceListData.length == 0) {
          this.attendanceListData.push({ __is_add: true });
          this.attendanceListForm = {
            attendanceName: '',
            beginTime: null,
            endTime: null,
          };
          this.editIndex = 0;
        }
        if (this.attendanceListData[this.attendanceListData.length - 1].__is_add) return;
        this.attendanceListData.push({ __is_add: true });
        this.attendanceListForm = {
          attendanceName: '',
          beginTime: null,
          endTime: null,
        };
        this.editIndex = this.attendanceListData.length - 1;
      },
      // 保存编辑
      onSaveattendance(row, index) {
        if (!this.attendanceListForm.attendanceName) return this.$message.error('请输入名称');
        if (!this.attendanceListForm.beginTime) return this.$message.error('请选择开始时间');
        if (!this.attendanceListForm.endTime) return this.$message.error('请选择结束时间');
        let data = new FormData();
        for (let key in this.attendanceListForm) {
          if (this.attendanceListForm[key] !== null && this.attendanceListForm[key] !== undefined) {
            data.append(key, this.attendanceListForm[key]);
          }
        }
        if (this.editType == 1) {
          //添加
          data.append('zjId', this.zjId);
          setAttendanceList(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.getTimeList(this.zjId);
              this.attendanceListData[index] = Object.assign({}, this.attendanceListForm, { __is_add: false });
              this.editIndex = null;
              this.attendanceListForm = {};
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        } else {
          //修改
          data.append('id', row.id);
          updateAttendanceList(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.attendanceListData[index] = Object.assign({}, this.attendanceListForm, { __is_add: false });
              this.getTimeList(this.zjId);
              this.editIndex = null;
              this.attendanceListForm = {};
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        }
      },
      // 取消编辑
      onCancelattendance(row, index) {
        if (row.__is_add) this.attendanceListData.splice(index, 1);
        this.editIndex = null;
        this.attendanceListForm = {};
      },
      // 修改行
      onEditattendance(row, index) {
        this.editType = 2;
        this.editIndex = index;
        this.attendanceListForm = Object.assign({}, row);
      },
      /* 删除行 */
      onRemoveattendance(row, index) {
        this.attendanceListData.splice(index, 1);
        delAttendanceList({ id: row.id }).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已删除' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 考勤内容设置弹窗 关闭前
      beforeClose() {
        if (this.editIndex != null) {
          this.$message.error('请先保存数据！');
        } else {
          this.showSetTeacherAttendance = false;
        }
      },
    },
  };
</script>

<style scoped></style>
